import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import HelpTip from "@/components/HelpTip";
import { toast } from "sonner";
import { ArrowUp, ArrowDown } from "lucide-react";

export default function AdminBestsellers() {
    const [products, setProducts] = useState([]);

    const load = async () => setProducts((await api.get("/admin/products")).data);
    useEffect(() => { load(); }, []);

    const toggle = async (p) => {
        try {
            await api.put("/admin/bestsellers", { product_id: p.id, is_bestseller: !p.is_bestseller, bestseller_order: p.is_bestseller ? null : (products.filter(x => x.is_bestseller).length) });
            load();
        } catch { toast.error("Failed"); }
    };

    const move = async (p, dir) => {
        const bs = products.filter(x => x.is_bestseller).sort((a, b) => (a.bestseller_order ?? 999) - (b.bestseller_order ?? 999));
        const idx = bs.findIndex(x => x.id === p.id);
        const swapIdx = dir === "up" ? idx - 1 : idx + 1;
        if (swapIdx < 0 || swapIdx >= bs.length) return;
        const other = bs[swapIdx];
        await api.put("/admin/bestsellers", { product_id: p.id, is_bestseller: true, bestseller_order: swapIdx });
        await api.put("/admin/bestsellers", { product_id: other.id, is_bestseller: true, bestseller_order: idx });
        load();
    };

    const bestsellers = products.filter(p => p.is_bestseller).sort((a, b) => (a.bestseller_order ?? 999) - (b.bestseller_order ?? 999));
    const others = products.filter(p => !p.is_bestseller);

    return (
        <div data-testid="admin-bestsellers">
            <div className="flex items-center gap-2 mb-6">
                <h1 className="font-display text-4xl tracking-tighter">Bestsellers</h1>
                <HelpTip>Pin products you want to feature on the homepage's "New In / Bestsellers" grid. Order matters — use arrows to reorder.</HelpTip>
            </div>

            <div className="bg-white border-2 border-black p-6 mb-6">
                <div className="font-mono text-xs uppercase mb-3">Pinned ({bestsellers.length})</div>
                {bestsellers.length === 0 ? (
                    <div className="font-mono text-xs text-neutral-500">None pinned yet. Pin products from the list below.</div>
                ) : (
                    <div className="space-y-2">
                        {bestsellers.map((p, i) => (
                            <div key={p.id} className="flex items-center gap-3 border-2 border-black p-3">
                                <div className="font-mono text-xs text-neutral-500 w-8">#{i + 1}</div>
                                {p.images?.[0] && <img src={p.images[0]} alt="" className="w-12 h-12 object-cover border border-black" />}
                                <div className="flex-1 font-medium">{p.name}</div>
                                <div className="font-mono text-[10px] text-neutral-500">clicks: {p.click_count || 0}</div>
                                <div className="font-mono text-xs">₹{p.price}</div>
                                <button onClick={() => move(p, "up")} disabled={i === 0} className="p-2 border-2 border-black disabled:opacity-30"><ArrowUp className="w-3 h-3" /></button>
                                <button onClick={() => move(p, "down")} disabled={i === bestsellers.length - 1} className="p-2 border-2 border-black disabled:opacity-30"><ArrowDown className="w-3 h-3" /></button>
                                <button onClick={() => toggle(p)} className="px-3 py-2 border-2 border-black font-mono text-xs uppercase">Unpin</button>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <div className="bg-white border-2 border-black p-6">
                <div className="font-mono text-xs uppercase mb-3">All Products — Click Pin to add to Bestsellers</div>
                {others.length === 0 ? (
                    <div className="font-mono text-xs text-neutral-500">All products are already pinned, or no products exist.</div>
                ) : (
                    <div className="grid md:grid-cols-2 gap-2">
                        {others.map(p => (
                            <div key={p.id} className="flex items-center gap-3 border-2 border-black p-3">
                                {p.images?.[0] && <img src={p.images[0]} alt="" className="w-12 h-12 object-cover border border-black" />}
                                <div className="flex-1 font-medium text-sm">{p.name}</div>
                                <div className="font-mono text-[10px] text-neutral-500">{p.click_count || 0} clicks</div>
                                <div className="font-mono text-xs">₹{p.price}</div>
                                <button onClick={() => toggle(p)} className="px-3 py-2 border-2 border-black font-mono text-xs uppercase">Pin</button>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
